import { create } from "zustand";

export type Client = {
  id: number;
  client_image: string;
  status: number;
};

type ClientStore = {
  clients: Client[];
  fetchClients: (lang: "en" | "id") => Promise<void>;
};

const baseUrl = "https://admin.talentlinkindo.com/api";

export const useClientStore = create<ClientStore>((set) => ({
  clients: [],

  fetchClients: async (lang) => {
    try {
      const res = await fetch(`${baseUrl}/${lang}/client`);
      if (!res.ok) throw new Error("Failed to fetch clients");

      const json = await res.json();
      set({ clients: json.data || [] });
    } catch (error) {
      console.error("Failed to fetch clients:", error);
    }
  },
}));
